import React from 'react';
import { Link } from 'gatsby';
import { links } from '../config/site';

export default function Header() {
  return (
    <header className="site-header">
      <div className="container site-header__inner">
        <Link to="/" className="brand" aria-label="Pascal home">
          <span className="brand__mark" aria-hidden="true">P</span>
          <span className="brand__name">Pascal</span>
        </Link>
        <nav className="site-nav" aria-label="Primary">
          <Link to="/personal" className="site-nav__link">Personal</Link>
          <Link to="/business" className="site-nav__link">Business</Link>
          <Link to="/#a-desktop" className="site-nav__link">Desktop</Link>
        </nav>
        <div className="site-header__actions">
          <a href={links.startFree} className="btn btn--primary btn--sm">Start free</a>
        </div>
      </div>
    </header>
  );
}
